function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

import Cookies from 'js-cookie/src/js.cookie';
import psl from 'psl/dist/psl'; // Order is important
// https://stackoverflow.com/questions/336859/var-functionname-function-vs-function-functionname
// https://stackoverflow.com/a/17791282

window.CookieConsent = function () {
  var self = {};
  var cookieName = 'cookies-allowed';
  var secureConnection = location.protocol === 'https:'; // Adapted from https://stackoverflow.com/a/30153391

  var serializeFormData = function serializeFormData(form) {
    var field,
        s = {};

    if (_typeof(form) == 'object' && form.nodeName == "FORM") {
      var len = form.elements.length;

      for (var i = 0; i < len; i++) {
        field = form.elements[i];

        if (field.name && !field.disabled && field.type != 'file' && field.type != 'reset' && field.type != 'submit' && field.type != 'button') {
          if (field.checked) {
            s[field.name] = encodeURIComponent(field.value);
          }
        }
      }
    }

    s = JSON.stringify(s);
    return s;
  };

  var allowCookies = function allowCookies(consentValue) {
    // console.log(consentValue);
    delete consentValue.accepted; //console.group('Cookie consent JavaScript output');
    // https://stackoverflow.com/questions/684672/how-do-i-loop-through-or-enumerate-a-javascript-object

    for (var property in consentValue) {
      if (!consentValue.hasOwnProperty(property)) {
        continue;
      }

      if (consentValue[property] == 'true') {
        var cookieCategory = property.replace('cookie_', '');
        cookieConsentEating.runCookieTypesScripts(cookieCategory);
        cookieConsentEating.runCookieTypesiFrames(cookieCategory);
      }
    }

    if (typeof cookieConsentCallback == 'function') {
      cookieConsentCallback();
    } //console.groupEnd();

  };

  var confirmConsent = function confirmConsent() {
    var consentValue = serializeFormData(document.querySelector('.cookie-warning__form'));
    recordConsent(consentValue);
    cookieConsentEating.querySelectorLoop('.cookie-warning', function (element) {
      element.classList.remove('cookie-warning--awaiting-confirmation');
    });
    window.removeEventListener('scroll', confirmConsent);
  };

  var recordConsent = function recordConsent(consentValue) {
    consentValue = JSON.parse(consentValue);
    consentValue.accepted = Date.now();
    consentValue.version = '2.0.5 (10-10-19:yarn/master)';
    Cookies.set(cookieName, consentValue, {
      expires: 365,
      secure: secureConnection,
      domain: document.querySelector('.cookie-warning').dataset.domain === undefined ? window.location.hostname : document.querySelector('.cookie-warning').dataset.domain
    });
    allowCookies(consentValue);
  };

  var registerCookieWarningEventListener = function registerCookieWarningEventListener() {
    cookieConsentEating.querySelectorLoop('.cookie-warning__button', function (element) {
      element.addEventListener('click', registerCookieWarningEvent, false);
    });
  };

  var registerCookieWarningEvent = function registerCookieWarningEvent(event) {
    confirmConsent();
    event.preventDefault();
  };

  var clearCookiesEventListener = function clearCookiesEventListener() {
    cookieConsentEating.querySelectorLoop('.cookie-warning__clear', function (element) {
      element.addEventListener('click', self.clearCookies, false);
    });
  };

  var changedAtCheck = function changedAtCheck(changedAt, cookieConsentValue) {
    // If the changed at timestamp is > accepted at date, reset cookie consent
    // as there is a potential that new cookies have been added so need
    // to be consented to
    if (new Date(changedAt).getTime() > new Date(cookieConsentValue.accepted).getTime()) {
      self.clearCookies();
      self.init();
    } // If the user has visited after the changed at timestamp, continue to allow
    // cookies, as they have already consented
    else {
        allowCookies(cookieConsentValue);
      }
  }; // https://stackoverflow.com/a/19832995
  // https://stackoverflow.com/a/881556


  var cookieConsentEating = {
    querySelectorLoop: function querySelectorLoop(selector, forEachFunction) {
      // https://stackoverflow.com/a/21319794
      // Is this faster? :shrug:
      var elements = document.querySelectorAll(selector);

      for (var i = 0, n = elements.length; i < n; i++) {
        forEachFunction(elements[i]);
      }
      /*
      Array.prototype.slice.call(document.querySelectorAll(selector))
        .forEach(forEachFunction);
      */

    },
    runCookieTypesScripts: function runCookieTypesScripts(cookieCategory) {
      this.querySelectorLoop('script[data-cookie-type="' + cookieCategory + '"]', function (element) {
        element.setAttribute('type', 'text/javascript');
        element.setAttribute('data-cookie-execute', 'true');
        var source = element.getAttribute('src');

        if (source == undefined) {
          eval(element.innerHTML);
        } else {
          // https://stackoverflow.com/a/28002292
          var script = document.createElement('script');
          var prior = document.getElementsByTagName('script')[0];
          script.async = 1;

          script.onload = script.onreadystatechange = function (_, isAbort) {
            if (isAbort || !script.readyState || /loaded|complete/.test(script.readyState)) {
              script.onload = script.onreadystatechange = null;
              script = undefined;
            }
          };

          script.src = source;
          prior.parentNode.insertBefore(script, prior);
        }
      });
    },
    runCookieTypesiFrames: function runCookieTypesiFrames(cookieCategory) {
      this.querySelectorLoop('iframe[data-cookie-type="' + cookieCategory + '"]', function (element) {
        element.setAttribute('data-cookie-execute', 'true');
        var src = element.getAttribute('data-src');
        element.setAttribute('src', src);
      });
    }
  };

  self.deactivate = function () {
    // Turbolinks re-appends the new head with the old, we want to remove what
    // we're done with so it does run twice, run twice it doesn't
    cookieConsentEating.querySelectorLoop('[data-cookie-execute=true]', function (element) {
      element.remove();
    });
  };

  self.init = function (changedAt) {
    var cookieConsentValue = Cookies.getJSON(cookieName);
    var cookieConsentChangedAt = document.querySelector('.cookie-warning').dataset.expireAt;
    console.log(cookieConsentValue);

    if (cookieConsentValue === undefined) {
      cookieConsentEating.querySelectorLoop('.cookie-warning', function (element) {
        element.classList.add('cookie-warning--awaiting-confirmation');
      });
      var requireClick = document.querySelector('.cookie-warning').dataset.requireClick;

      if (requireClick === undefined) {
        window.addEventListener('scroll', confirmConsent);
      }
    } else if (cookieConsentValue.accepted === undefined) {
      self.clearCookies();
      self.init();
    } else if (cookieConsentChangedAt !== undefined) {
      changedAtCheck(cookieConsentChangedAt, cookieConsentValue);
    } else {
      allowCookies(cookieConsentValue);
    }

    registerCookieWarningEventListener();
    clearCookiesEventListener();
  };

  self.clearCookies = function () {
    // https://stackoverflow.com/a/32263695
    // https://stackoverflow.com/a/27374628
    var expiry = 'expires=' + new Date().toUTCString();
    var path = 'path=/';
    var fqdomain = 'domain=.' + psl.parse(document.domain).domain;
    var docdomain = 'domain=.' + document.domain;
    document.cookie.split(";").forEach(function (c) {
      document.cookie = c.replace(/^ +/, '').replace(/=.*/, '=;' + expiry + ';' + path);
      document.cookie = c.replace(/^ +/, "").replace(/=.*/, '=;' + expiry + ';' + fqdomain + ';' + path);
      document.cookie = c.replace(/^ +/, "").replace(/=.*/, '=;' + expiry + ';' + docdomain + ';' + path);
    });
  };

  return self;
}(); // CookieConsent.clearCookies();


var cookieConsentinitializer;

if (typeof Turbolinks == 'undefined') {
  cookieConsentinitializer = 'DOMContentLoaded';
} else {
  cookieConsentinitializer = 'turbolinks:load';
  document.addEventListener('turbolinks:before-visit', CookieConsent.deactivate);
}

document.addEventListener(cookieConsentinitializer, CookieConsent.init);